module.exports = __webpack_public_path__ + "img/best-analytics-measurement-impact-solution.0f4154a4.png";